// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"bd0b2616","453":"123d81cd","455":"57a0f2fe","977":"a9691384"}[chunkId] + ".chunk.js";
};